import { inject, Injectable } from "@angular/core";
import { Database, objectVal, ref } from "@angular/fire/database";
import { combineLatest, map, shareReplay, startWith, timer } from "rxjs";
import { Profile } from './vs.models';
import { getAlliance } from "./vs.util";


@Injectable({
  providedIn: 'root',
})
export class VsService {
  protected readonly db = inject(Database);

  // Shared timer to synchronize regular updates.
  private readonly oneSecondTimer$ = timer(0, 1000);

  private getServerOffset() {
    return objectVal<number>(ref(this.db, `.info/serverTimeOffset`)).pipe(shareReplay(1));
  }

  nowTimer(interval = 1000) {
    const timer$ = interval === 1000 ? this.oneSecondTimer$.pipe(startWith(0)) : timer(0, interval);
    return combineLatest([this.getServerOffset(), timer$]).pipe(map(([offset]) => Date.now() + offset));
  }

  getProfile(eventKey: string, uid: string, allowUnapproved?: boolean) {
    return objectVal<Profile | null>(ref(this.db, `events/${eventKey}/profiles/${uid}`)).pipe(
      map((profile) => {
        if (profile) {
          profile.alliance = getAlliance(uid);
        }
        if(profile?.state === 'rejected' && profile.points) {
          profile.points = Math.floor(profile.points / 2);
        }

        return !allowUnapproved && profile?.state !== 'approved' ? undefined : profile;
      })
    );
  }

  getEventName(eventKey: string) {
    return objectVal<string | null>(ref(this.db, `events/${eventKey}/name`));
  }

  getCurrentActivityKey(eventKey: string) {
    return objectVal<string | null>(ref(this.db, `events/${eventKey}/currentActivity`));
  }

  getCurrentSurveyKey(eventKey: string) {
    return objectVal<string | null>(ref(this.db, `events/${eventKey}/currentSurvey`));
  }
}
